import React from 'react'
import SVG from 'react-inlinesvg'

interface InlineSvgProps {
    /** SVG URL */
    src: string
    /** Size of the SVG */
    size?: string | number
    /** Additional CSS class */
    className?: string
    /** Additional inline styles */
    style?: React.CSSProperties
    /** Alt text for accessibility */
    alt?: string
    /** Type of color attribute to replace with currentColor */
    colorType?: 'fill' | 'stroke' | 'original'
}

export function InlineSvg({
    src,
    size,
    className,
    style,
    alt,
    colorType = 'fill',
}: InlineSvgProps) {
    // Create preprocessor function to replace colors with currentColor and make the other transparent
    const preProcessor = (code: string): string => {
        let processedCode = code
        if (colorType === 'original') {
            return code
        }

        if (colorType === 'fill') {
            // Replace existing fill colors with currentColor and make stroke transparent
            processedCode = code.replace(/fill="[^"]*"/g, 'fill="currentColor"')
            processedCode = processedCode.replace(
                /stroke="[^"]*"/g,
                'stroke="transparent"',
            )
        } else if (colorType === 'stroke') {
            // Replace existing stroke colors with currentColor and make fill transparent
            processedCode = code.replace(
                /stroke="[^"]*"/g,
                'stroke="currentColor"',
            )
            processedCode = processedCode.replace(
                /fill="[^"]*"/g,
                'fill="transparent"',
            )
        }

        return processedCode
    }

    // Determine size styles
    const sizeStyle = size
        ? {
              width: typeof size === 'number' ? `${size}px` : size,
              height: typeof size === 'number' ? `${size}px` : size,
          }
        : {}

    return (
        <SVG
            src={src}
            className={className}
            style={{
                ...sizeStyle,
                ...style,
            }}
            preProcessor={preProcessor}
        />
    )
}
